<div class="card">
  <p-card i18n-header header="Master data">
    <input pInputText type="text" [(ngModel)]="data.name" i18n-placeholder placeholder="Name" />
    <input
      pInputText
      type="text"
      [(ngModel)]="data.cooktimeS"
      i18n-placeholder
      placeholder="cooktimeS"
    />
    <input
      pInputText
      type="text"
      [(ngModel)]="data.oventimeS"
      i18n-placeholder
      placeholder="oventimeS"
    />
    <input
      pInputText
      type="text"
      [(ngModel)]="data.timeSpentInKichenS"
      placeholder="timeSpentInKichenS"
    />
    <input
      pInputText
      type="text"
      [(ngModel)]="data.totalTimeS"
      i18n-placeholder
      placeholder="totalTimeS"
    />
    <p-select
      [options]="categories"
      optionLabel="category"
      optionValue="id"
      appendTo="body"
      [(ngModel)]="categoryId"
      [style]="{ width: '100%' }"
    />
  </p-card>
</div>
<div class="card">
  <p-card i18n-header header="Ingridiens">
    <p-button
      i18n-label
      label="Add New Row"
      icon="pi pi-plus"
      (click)="addRow()"
      severity="secondary"
    />

    <p-table
      [value]="data.ingredients"
      dataKey="id"
      editMode="row"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template #header>
        <tr>
          <th style="width: 29%" i18n>Amount</th>
          <th style="width: 29%" i18n>Type</th>
          <th style="width: 29%" i18n>Ingridienc</th>
          <th style="width: 12%" i18n></th>
        </tr>
      </ng-template>
      <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="row">
          <td>
            <p-cellEditor>
              <ng-template #input>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="row.ammount"
                  i18n-placeholder
                  placeholder="Enter amount"
                />
                to
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="row.ammount2"
                  i18n-placeholder
                  placeholder="Enter amount"
                />
              </ng-template>
              <ng-template #output>
                @if (row.ammount > 0 || (row.ammount > 0 && row.ammount2 > 0)) {
                  {{ row.ammount }}
                }
                @if (row.ammount2 > row.ammount) {
                  -{{ row.ammount2 }}
                }
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template #input>
                <p-select
                  [options]="types"
                  optionLabel="type"
                  optionValue="id"
                  appendTo="body"
                  [(ngModel)]="row.type.id"
                  [style]="{ width: '100%' }"
                />
              </ng-template>
              <ng-template #output>
                @if (!(row.amount > 0 || (row.amount > 0 && row.amount2 > 0))) {
                  @for (unit of types; track unit.id) {
                    @if (row.unit.id == unit.id) {
                      {{ unit.unit }}
                    }
                  }
                }
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template #input>
                <p-select
                  [options]="ingredients"
                  optionLabel="name"
                  optionValue="id"
                  appendTo="body"
                  [(ngModel)]="row.ingredients.id"
                  [style]="{ width: '100%' }"
                />
              </ng-template>
              <ng-template #output>
                @for (ingredient of ingredients; track ingredient.id) {
                  @if (row.ingredients.id == ingredient.id) {
                    {{ ingredient.name }}
                  }
                }
              </ng-template>
            </p-cellEditor>
          </td>

          <td>
            <div class="flex items-center justify-center gap-2">
              @if (row.isEditing == false) {
                <button
                  pButton
                  pRipple
                  type="button"
                  pInitEditableRow
                  icon="pi pi-pencil"
                  (click)="enableEditMode(row)"
                  text
                  rounded
                  severity="secondary"
                ></button>
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (click)="deleteEdit(row)"
                />
              } @else {
                <button
                  pButton
                  pRipple
                  type="button"
                  pSaveEditableRow
                  icon="pi pi-check"
                  (click)="updateRow(row)"
                  text
                  rounded
                  severity="secondary"
                ></button>
                <button
                  pButton
                  pRipple
                  type="button"
                  pCancelEditableRow
                  icon="pi pi-times"
                  (click)="cancelEdit(row)"
                  text
                  rounded
                  severity="secondary"
                ></button>
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<div class="card">
  <p-card i18n-header header="Servings">
    <input
      pInputText
      type="text"
      [(ngModel)]="data.servings"
      i18n-placeholder
      placeholder="Servings"
    />
    <input
      pInputText
      type="text"
      [(ngModel)]="data.servings2"
      i18n-placeholder
      placeholder="Servings2"
    />
    <input
      pInputText
      type="text"
      [(ngModel)]="data.servingsNode"
      i18n-placeholder
      placeholder="ServingsNode"
    />
  </p-card>
  <p-card i18n-header header="Description">
    <p-editor [(ngModel)]="data.description" [style]="{ height: '320px' }" />
    <input
      pInputText
      type="text"
      [(ngModel)]="data.endDescription"
      pi18n-placeholder
      laceholder="EndDescription"
    />
  </p-card>
</div>
<div class="card">
  <p-card i18n-header header="Actions">
    <p-button i18n-label label="save" icon="pi pi-plus" (click)="Save()" severity="secondary" />
    <p-button i18n-label label="cansle" icon="pi pi-plus" (click)="Cansle()" severity="secondary" />
  </p-card>
</div>
